import { Component, inject } from '@angular/core';
import { SupplierBankService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SupplierBankCreateDto,
  SupplierBankDto,
  SupplierBankExcelDownloadDto,
  SupplierBankUpdateDto,
} from '../proxy/controlling/dtos/supplier-bank';
import { SUPPLIERBANK_CONFIG, SUPPLIERBANK_FIELDS } from './supplier-bank.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-supplier-bank',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SupplierBankService, ConfirmationService],
  templateUrl: './supplier-bank.html',
  styleUrl: './supplier-bank.scss',
})
export class SupplierBank extends BaseCrudComponent<
  SupplierBankDto,
  SupplierBankCreateDto,
  SupplierBankUpdateDto,
  SupplierBankExcelDownloadDto
> {
  service = inject(SupplierBankService);
  config = SUPPLIERBANK_CONFIG;
  fields = SUPPLIERBANK_FIELDS;

  protected prepareUpdateDto(data: any, selected: SupplierBankDto): SupplierBankUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SupplierBank';
  }
}
